<template>
<div class="game-switch-wrapper">
  <div class="game-switch d-flex-v">
      <div v-for="a in games" :key="a.productCode" class="game-icon"
        @click="jumpPage(a)" :class="{
            'is-disabled': !a.isEnabled,
            'is-current': isCurrent(a.productCode)
        }">
          <el-avatar shape="square" :size="48" :src="$p(a.appIcon)"></el-avatar>
      </div>
  </div>
</div>
</template>

<script>
import { delay } from '@/util/util';
// import info from "@/packages/apps";
export default {
    props: {
        app: { },
        games: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
        }
    },
    computed: {
        currentApp: {
            get() {
                return this.app;
            },
            set(v) {
                this.$emit("update:app", v);
            }
        }
    },
    watch: {
        "$route"() {
            this.updateCurrent();
        }
    },
    methods: {
        async jumpPage(app) {
            if (app.isEnabled && !this.isCurrent(app.productCode)) {
                this.currentApp = null;
                await this.$nextTick();
                this.$router.push("./" + app.productCode);
            }
        },
        isCurrent(code) {
            return this.$route.path.endsWith(code);
        },
        updateCurrent() {
            const app = this.games.filter(g => this.$route.path.endsWith(g.productCode))[0];
            this.currentApp = app;
        }
    }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.game-switch-wrapper {
    position: absolute;
    right: 8px; 
    top: 0;   
    z-index: 90;
    height: 100%;
    display: flex;
    align-items: center;
    width: 0;
    .game-switch {
        position: relative;
        right: 66px;
        border: 1px solid #d7dae2;
        background-color: white;
        align-items: center;
        padding: 8px 0;  
        .game-icon {
            cursor: pointer;
            position: relative;
            height: 56px;
            padding:4px 8px;
            &.is-disabled {
                cursor: not-allowed;
                filter: grayscale(1);
            }
            &.is-current {
                background-color: $primary-light-5;
            }
        }
    }    
}

</style>